<template>
  <q-layout class="theme-1" view="hHh lpr lFr">
    <Header v-if="isUserLogged && isChangePassWord && !isExternalRoute" @collapseToggle="onCollapseToggle" />

    <q-drawer class="bg-light tw-side-nav fit" show-if-above v-if="isUserLogged && isChangePassWord && !isExternalRoute"
      v-model="leftDrawerOpen" side="left" :width="256" :mini="sidebarMini" :mini-width="72">
      <Sidebar v-on:closeDrawer="closeTheDrawer($event)" />

    </q-drawer>

    <q-page-container :class="{ 'pr-5': !isExternalRoute }">
      <confirmation-dialog :show="showConfirmationDialog" />
      <confirmation-delete-dialog :show="showConfirmationDeleteDialog" />
      <router-view v-if="canDisplayContent" />
      <div class="preloader-container" v-else>
        <svg class="logo-container" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 869.5 869.5">
          <g>
            <path
              d="M320.59,434.13c0,7.53.77,14.89,2.12,22.03h361.98c.57-6.99.88-14.02.88-21.12,0-130.48-99.09-244.32-238.64-250.75-3.69-.19-11.09-.31-12.22-.33h-.23c-.39,0-.76.06-1.15.08h.02c-137.87.73-249.4,112.7-249.4,250.74h0c0,138.09,111.63,250.09,249.58,250.74v.03h1.16c.33,0,.64-.05.95-.05,116.15-1.01,205.92-75.93,236.93-174.17h-86.16c-27.25,55.43-83.82,93.59-152.45,93.84.25,0,.48.02.73.02-94.1,0-170.39-76.29-170.39-170.39h0c0-94.1,76.29-170.39,170.39-170.39v-.03h-.03.06c79.49.12,142.89,51.47,163.4,121.43h-267.25c-6.57,14.8-10.29,31.13-10.29,48.37l.02-.05h0Z"
              class="white-path" />
            <path
              d="M434.75,88.24c191.07,0,346.53,155.46,346.53,346.53,0-24.37,19.75-44.11,44.11-44.11s44.11,19.75,44.11,44.11C869.5,195.05,674.48.02,434.75.02c-24.37,0-44.11,19.75-44.11,44.11s19.75,44.11,44.11,44.11h0Z"
              class="green-path" />
            <path
              d="M825.38,390.64c-24.37,0-44.11,19.75-44.11,44.11,0,191.07-155.46,346.53-346.53,346.53,24.37,0,44.11,19.75,44.11,44.11s-19.75,44.11-44.11,44.11c239.72,0,434.75-195.02,434.75-434.75,0-24.37-19.75-44.11-44.11-44.11h0Z"
              class="pink-path" />
            <path
              d="M434.75,781.28c-191.07,0-346.53-155.46-346.53-346.53,0,24.37-19.75,44.11-44.11,44.11S0,459.11,0,434.75c0,239.72,195.02,434.75,434.75,434.75,24.37,0,44.11-19.75,44.11-44.11s-19.75-44.11-44.11-44.11h0Z"
              class="blue-path" />
            <path
              d="M390.64,44.11c0-24.37,19.75-44.11,44.11-44.11C195.03,0,0,195.02,0,434.75c0,24.37,19.75,44.11,44.11,44.11s44.11-19.75,44.11-44.11c0-191.07,155.46-346.53,346.53-346.53-24.37,0-44.11-19.75-44.11-44.11h0Z"
              class="yellow-path" />
          </g>
        </svg>
      </div>
    </q-page-container>

    <div v-if="!isExternalRoute" class="tw-aside-tools">
      <div class="tw-aside-tools-wrapper">
        <div v-if="getsimulationPanelStatusFromRoute.status" class="z-top">

          <OrderSummaryPanel
            v-if="
              isTaskModuleOrder && getsimulationPanelStatusFromRoute.type === 'summary'
              && ((getSelectedSearchOrderItem.length === 1 && currentRoute === 'order') || (getSelectedSearchOrderItem.length === 0 && currentRoute === 'order-edit')
                || (getselectedTasks.length === 1 && currentRoute === 'task-list' && getselectedOrder) || (getselectedTasks.length === 0 && currentRoute === 'TaskDetail'))" />
        </div>
        <div class="mt-2">
          <div v-if="isUserLogged && isChangePassWord && !isExternalRoute" class="tw-message-drawer">

            <!-- <ControlsButton />-->
            <PrintDocumentButton v-if="getsimulationPanelStatusFromRoute.showPrintDocument" />
            <GoToDelivery
              v-if="
                isTaskModuleOrder && getsimulationPanelStatusFromRoute.type === 'summary' && currentRoute === 'order-edit'" />
            <DocumentsHistory
              v-if="isTaskModuleOrder && getsimulationPanelStatusFromRoute.type === 'summary' && getsimulationPanelStatusFromRoute.status && !['order', 'task-list'].includes(currentRoute)" />
            <OtsButton
              v-if="isTaskModuleOrder && getsimulationPanelStatusFromRoute.type === 'summary' && getsimulationPanelStatusFromRoute.status && !['order', 'task-list'].includes(currentRoute) && env === 'BODEMER'" />
          </div>
        </div>

      </div>
    </div>
  </q-layout>
</template>

<script>
import { computed, provide, ref } from "vue";
import Header from "@/components/layout/Header";
import Sidebar from "@/components/layout/Sidebar";
import Communication from "@/components/layout/Communication.vue";
import store from "@/store";
import ConfirmationDialog from "@/components/general/ConfirmationDialog";
import ConfirmationDeleteDialog from "@/components/general/ConfirmationDeleteDialog.vue";
import { useRoute } from "vue-router";
import { globalConfig, trackJWTStatus, connectedUserconfigurationEnv } from "@/utils";
import SummaryPanel from "@/components/summary-panel/SummaryPanel.vue";
import DemandSimulationSummary from "@/components/demand/simulation/DemandSimulationSummary.vue";
import ControlsButton from "@/components/controls/ControlsButton.vue";
import OrderSummaryPanel from "@/components/summary-panel/order/OrderSummaryPanel.vue";
import PrintDocumentButton from "@/components/document/PrintDocumentButton.vue";
import AlertButton from "@/components/alert/AlertButton.vue";
import GoToDelivery from "@/components/alert/GoToDelivery.vue";
import FilterList from "@/components/filter/FilterList.vue";
import DocumentsHistory from "@/components/alert/DocumentsHistory/DocumentsHistory.vue";
import OtsButton from "@/components/ots/OtsButton.vue";
import { settings } from "@/settings";

// Point de rupture par defaut du q-drawer Quasar : en dessous, le tiroir est
// superpose et le mode mini est ignore par Quasar.
const SIDEBAR_MINI_BREAKPOINT = 1023;

export default {
  components: {
    OrderSummaryPanel,
    Header,
    Sidebar,
    Communication,
    ConfirmationDialog,
    SummaryPanel,
    DemandSimulationSummary,
    ConfirmationDeleteDialog,
    ControlsButton,
    PrintDocumentButton,
    FilterList,
    AlertButton,
    GoToDelivery,
    DocumentsHistory,
    OtsButton
  },
  setup() {
    store.subscribe((mutation, state) => {
      const thirdUpdateMutations = [
        "thirdModule/setThirdSelected",
        "demandModule/editOffer",
        "simulationModule/initSimulation",
        "authModule/setUser",
      ];
      const orderUpdateMutations = [
        "orderModule/setOrder"
      ];
      const taskUpdateMutations = [
        "taskModule/setTask"
      ];
      const ordertaskUpdateMutations = [
        "taskModule/setOrder"
      ];
      const supersetConfigUpdateMutations = [
        "authModule/setSupersetConfig"
      ];
      const logoConfigUpdateMutations = [
        "authModule/setLogoConfig"
      ];
      const configurationUpdateMutations = [
        "authModule/setConfiguration"
      ];
      const userNetworkNodesUpdateMutations = [
        "authModule/setUserNetworksList",
        "authModule/setSelectedUserNetwork",
      ];
      const userPartyUpdateMutations = [
        "authModule/setPartyUser",
      ];
      const userPreferencesUpdataMutations = [
        "authModule/setUserPreferences"
      ]
      if (thirdUpdateMutations.indexOf(mutation.type) !== -1) {
        switch (mutation.type) {
          case "thirdModule/setThirdSelected":
            localStorage.setItem(
              globalConfig.storageKeys.thirdModule,
              JSON.stringify(state.thirdModule)
            );
            break;
          case "demandModule/editOffer":
            localStorage.setItem(
              globalConfig.storageKeys.demandModule,
              JSON.stringify(state.demandModule)
            );
            break;
          case "simulationModule/initSimulation":
            localStorage.setItem(
              globalConfig.storageKeys.simulationModule,
              JSON.stringify(state.simulationModule)
            );
            break;
          case "authModule/setUser":
            localStorage.setItem(
              globalConfig.storageKeys.authModule,
              JSON.stringify(state.authModule)
            );
            break;
        }
      }
      if (orderUpdateMutations.indexOf(mutation.type) !== -1) {
        const orderResourceUid = {
          resourceUid: state.orderModule.order.resourceUid
        }
        if (mutation.type === "orderModule/setOrder") {
          localStorage.setItem(
            globalConfig.storageKeys.orderModule,
            JSON.stringify(orderResourceUid)
          );
        }
      }
      if (taskUpdateMutations.indexOf(mutation.type) !== -1) {
        const task = {
          selectedTask: state.taskModule.selectedTask
        }
        if (mutation.type === "taskModule/setTask") {
          localStorage.setItem(
            globalConfig.storageKeys.taskModule,
            JSON.stringify(task)
          );
        }
      }
      if (ordertaskUpdateMutations.indexOf(mutation.type) !== -1) {
        const orderResourceUid = {
          resourceUid: state.taskModule.order.resourceUid
        }
        if (mutation.type === "taskModule/setOrder") {
          localStorage.setItem(
            globalConfig.storageKeys.orderTask,
            JSON.stringify(orderResourceUid)
          );
        }
      }
      if (supersetConfigUpdateMutations.indexOf(mutation.type) !== -1) {
        const superSetConfig = state.authModule.superSetConfig ? state.authModule.superSetConfig : undefined
        if (mutation.type === "authModule/setSupersetConfig") {
          localStorage.setItem(
            globalConfig.storageKeys.supersetConfig,
            JSON.stringify(superSetConfig)
          );
        }
      }
      if (logoConfigUpdateMutations.indexOf(mutation.type) !== -1) {
        const logoConfig = state.authModule.logoConfig ? state.authModule.logoConfig : undefined
        if (mutation.type === "authModule/setLogoConfig") {
          localStorage.setItem(
            globalConfig.storageKeys.logoConfig,
            JSON.stringify(logoConfig)
          );
        }
      }
      if (configurationUpdateMutations.indexOf(mutation.type) !== -1) {
        const configuration = state.authModule.configuration ? state.authModule.configuration : undefined
        if (mutation.type === "authModule/setConfiguration") {
          localStorage.setItem(
            globalConfig.storageKeys.configuration,
            JSON.stringify(configuration)
          );
        }
      }
      if (userNetworkNodesUpdateMutations.indexOf(mutation.type) !== -1) {
        const userNetworksList = state.authModule?.userNetworksList && state.authModule?.userNetworksList.length ? state.authModule?.userNetworksList : []
        const selectedUserNetwork = state.authModule?.selectedUserNetwork ? state.authModule?.selectedUserNetwork : undefined
        const toStore = {
          userNetworksList,
          selectedUserNetwork
        };
        if (mutation.type === "authModule/setUserNetworksList" || "authModule/setSelectedUserNetwork") {
          localStorage.setItem(
            globalConfig.storageKeys.userNetworkNodes,
            JSON.stringify(toStore)
          );
        }
      }
      if (userPartyUpdateMutations.indexOf(mutation.type) !== -1) {
        const partyUser = state.authModule.partyUser ? state.authModule.partyUser : undefined
        if (mutation.type === "authModule/setPartyUser") {
          localStorage.setItem(
            globalConfig.storageKeys.partyUser,
            JSON.stringify(partyUser)
          );
        }
      }
      if (userPreferencesUpdataMutations.indexOf(mutation.type) !== -1) {
        const userPreferences = state.authModule.userPrefrences ? state.authModule.userPrefrences : undefined
        if (mutation.type === "authModule/setUserPrefrences") {
          localStorage.setItem(
            globalConfig.storageKeys.userPrefrences,
            JSON.stringify(userPreferences)
          );
        }
      }
    });
    const drawerRightWidth = ref(20);

    const bar = ref(null);
    const leftDrawerOpen = ref(false);
    const rightDrawerOpen = ref(true);
    const currentRoute = computed(() => {
      return useRoute().name;
    });
    const summaryPanelStatus = ref(false);
    const summaryPanelType = ref(null);
    const appVersion = `${settings.appVersion}`;
    const showPrintDocument = ref(false);
    // Menu replie : les icones restent visibles, les libelles passent en
    // infobulle. Partage avec Sidebar/NavItem par injection.
    const sidebarMini = ref(false);
    provide("sidebarMini", sidebarMini);
    return {
      leftDrawerOpen,
      rightDrawerOpen,
      sidebarMini,
      currentRoute,
      bar,
      drawerRightWidth,
      appVersion,
    };
  },
  computed: {
    isTaskModuleOrder() {
      return store.getters["taskModule/isTaskModuleOrder"];
    },
    getSelectedSearchOrderItem() {
      return store.state.orderModule.selectedSearchOrderItem
        ? store.state.orderModule.selectedSearchOrderItem
        : []
    },
    getselectedOrder() {
      return store.state.summaryPanelModule.order
    },
    getselectedTasks() {
      return store.state.taskModule.assignReassign && store.state.taskModule.assignReassign.selectedTasks
        ? store.state.taskModule.assignReassign.selectedTasks
        : []
    },
    getsimulationPanelStatusFromRoute() {
      switch (this.currentRoute) {
        case "mo-demand-detail": {
          this.summaryPanelStatus = true;
          if (this.$store.state.middleOfficeModule.offer) {
            this.summaryPanelType = "summary";
          } else {
            this.summaryPanelType = "simulation";
          }

          break;
        }

        case "demand-edit": {
          if (this.$store.state.demandModule?.offer?.resourceUid) {
            this.summaryPanelStatus = true;
            this.showPrintDocument = true;
          } else {
            this.summaryPanelStatus = false;
            this.showPrintDocument = false;
          }

          this.summaryPanelType = "summary";

          break;
        }

        case "order-edit": {
          if (this.$store.state.orderModule?.order?.resourceUid) {
            this.summaryPanelStatus = true;
            this.showPrintDocument = true;
          } else {
            this.summaryPanelStatus = false;
            this.showPrintDocument = false;
          }
          this.summaryPanelType = "summary";

          break;
        }
        case "order": {
          if (this.$store.state.orderModule?.order?.resourceUid) {
            this.summaryPanelStatus = true;
          } else {
            this.summaryPanelStatus = false;
          }
          this.summaryPanelType = "summary";
          this.showPrintDocument = false;

          break;
        }

        case "TaskDetail": {
          this.summaryPanelStatus = true;
          this.summaryPanelType = "summary";
          this.showPrintDocument = true;
          break;
        }
        case "task-list": {
          this.summaryPanelStatus = true;
          this.summaryPanelType = "summary";
          this.showPrintDocument = false;
          break;
        }

        case "third-edit": {
          this.showPrintDocument = true;
          break;
        }

        default:
          this.summaryPanelStatus = false;
          this.summaryPanelType = null;
          this.showPrintDocument = false;
          break;
      }

      return {
        status: this.summaryPanelStatus,
        type: this.summaryPanelType,
        showPrintDocument: this.showPrintDocument
      };
    },

    showConfirmationDialog() {
      return (
        store.state.confirmationDialogState && store.state.confirmationDialogState.show
      );
    },
    isUserLogged() {
      return !!(store.state.authModule.user && store.state.authModule.user.loggedIn);
    },
    isChangePassWord() {
      return store.state.authModule.changePassworIn;
    },
    isExternalRoute() {
      return !!this.$route.meta?.hideLayout;
    },
    showConfirmationDeleteDialog() {
      return (
        store.state.confirmationDeleteDialogState &&
        store.state.confirmationDeleteDialogState.show
      );
    },
    canDisplayContent() {
      return ((this.isUserLogged && this.isChangePassWord) || !this.$route.meta.userRequired)
    },
    env() {
      return connectedUserconfigurationEnv()
    }
  },
  watch: {},
  created() {
    this.applyTheme(settings.theme)
    store.dispatch("authModule/initializeAuth");

    trackJWTStatus();
  },
  mounted() {
    document.title = `E-FLO`;
    this.handleSessionChange();
  },
  methods: {
    handleSessionChange: function () {
      window.onstorage = () => {
        if (localStorage.getItem("token") !== null) {
          return;
        }
        if (!document.hidden) {
          return;
        }
        sessionStorage.clear();
        window.location.reload();
      };
    },
    applyTheme(theme) {
      const themeObj = JSON.parse(theme)
      for (const [key, value] of Object.entries(themeObj)) {
        document.documentElement.style.setProperty(key, value);
      }
    },
    openSummary() {
      store.state.middleOfficeModule.showSummary = !store.state.middleOfficeModule
        .showSummary;
    },
    closeTheDrawer(leftDrawerOpen) {
      this.leftDrawerOpen = !leftDrawerOpen;
    },
    /**
     * Sur grand ecran le bouton replie le menu en mode icones ; sous le point
     * de rupture du q-drawer le mode mini est inoperant, on ouvre/ferme donc
     * le panneau superpose comme avant.
     */
    onCollapseToggle() {
      if (this.$q.screen.width <= SIDEBAR_MINI_BREAKPOINT) {
        this.leftDrawerOpen = !this.leftDrawerOpen;
      } else {
        this.sidebarMini = !this.sidebarMini;
      }
    },
  },
};
</script>
<style>
.logo-container {
  width: 64px;
  height: 64px;
}

.logo-container path {
  transform-origin: center;
}

.logo-container .yellow-path {
  fill: #ffb100;
  animation: spin-smooth 1.4s cubic-bezier(0.5, 0, 0.5, 1) infinite;
  animation-delay: -0.45s;
}

.logo-container .blue-path {
  fill: #0065ff;
  animation: spin-smooth 1.4s cubic-bezier(0.5, 0, 0.5, 1) infinite;
  animation-delay: -0.3s;
}

.logo-container .pink-path {
  fill: #ff6ce4;
  animation: spin-smooth 1.4s cubic-bezier(0.5, 0, 0.5, 1) infinite;
  animation-delay: -0.15s;
}

.logo-container .green-path {
  fill: #00e1af;
  animation: spin-smooth 1.4s cubic-bezier(0.5, 0, 0.5, 1) infinite;
  animation-delay: 0s;
}

.logo-container .white-path {
  fill: #000742;
  animation: pulse 1.4s ease-in-out infinite;
}

@keyframes spin-smooth {
  0% {
    transform: rotate(0deg);
    opacity: 0.4;
  }

  25% {
    opacity: 1;
  }

  50% {
    transform: rotate(180deg);
    opacity: 0.4;
  }

  75% {
    opacity: 1;
  }

  100% {
    transform: rotate(360deg);
    opacity: 0.4;
  }
}

@keyframes pulse {

  0%,
  100% {
    transform: scale(1);
    opacity: 0.85;
  }

  50% {
    transform: scale(0.97);
    opacity: 1;
  }
}

.preloader-container {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: #ffffff;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
</style>
